if (!customElements.get('lead-capture-form')) {
  customElements.define(
    'lead-capture-form',
    class LeadCaptureForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        if (!this.form) return;

        this.emailInput = this.querySelector('[data-email]');
        this.honeypot = this.querySelector('[data-honeypot]');
        this.submitButton = this.querySelector('[data-submit]');
        this.buttonLabel = this.querySelector('[data-button-label]');
        this.status = this.querySelector('[data-status]');
        this.formRegion = this.querySelector('[data-form-region]');
        this.successRegion = this.querySelector('[data-success-region]');
        this.successHeading = this.querySelector('[data-success-heading]');

        this.listId = this.dataset.listId;
        this.companyId = this.dataset.companyId;
        this.revision = this.dataset.revision;
        this.sendingLabel = this.dataset.sendingLabel || 'Sending...';
        this.errorInvalid = this.dataset.errorInvalid || 'Please enter a valid email address.';
        this.errorFailed = this.dataset.errorFailed || 'Something went wrong. Please try again in a moment.';

        this.originalLabel = this.buttonLabel ? this.buttonLabel.textContent : '';

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInput = this.handleInput.bind(this);
        this.form.addEventListener('submit', this.handleSubmit);
        this.emailInput.addEventListener('input', this.handleInput);
      }

      disconnectedCallback() {
        if (this.form) this.form.removeEventListener('submit', this.handleSubmit);
        if (this.emailInput) this.emailInput.removeEventListener('input', this.handleInput);
      }

      handleInput() {
        if (this.status.textContent) this.clearStatus();
      }

      clearStatus() {
        this.status.textContent = '';
        this.status.classList.remove('lead-capture__status--error');
      }

      isValidEmail(value) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      }

      setLoading(isLoading) {
        this.submitButton.disabled = isLoading;
        this.submitButton.setAttribute('aria-busy', String(isLoading));
        if (this.buttonLabel) {
          this.buttonLabel.textContent = isLoading ? this.sendingLabel : this.originalLabel;
        }
      }

      showError(message) {
        this.setLoading(false);
        this.status.textContent = message;
        this.status.classList.add('lead-capture__status--error');
      }

      showSuccess() {
        this.clearStatus();
        this.formRegion.hidden = true;
        this.successRegion.hidden = false;
        if (this.successHeading) this.successHeading.focus();
      }

      async handleSubmit(event) {
        event.preventDefault();
        this.clearStatus();

        // Honeypot — silently fake success, no API call.
        if (this.honeypot && this.honeypot.value !== '') {
          this.showSuccess();
          return;
        }

        const email = this.emailInput.value.trim();
        if (!this.isValidEmail(email)) {
          this.showError(this.errorInvalid);
          this.emailInput.focus();
          return;
        }

        this.setLoading(true);

        try {
          const response = await fetch(
            `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(this.companyId)}`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                revision: this.revision,
              },
              body: JSON.stringify({
                data: {
                  type: 'subscription',
                  attributes: {
                    profile: {
                      data: {
                        type: 'profile',
                        attributes: { email },
                      },
                    },
                  },
                  relationships: {
                    list: { data: { type: 'list', id: this.listId } },
                  },
                },
              }),
            }
          );

          if (!response.ok) throw new Error(`Klaviyo subscribe failed: ${response.status}`);
          this.showSuccess();
        } catch (err) {
          console.warn('[lead-capture]', err);
          this.showError(this.errorFailed);
        }
      }
    }
  );
}
